import { Fragment } from "react";
// import { Fragment, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchAllRestaurants, selectRestaurant } from "../../redux/restaurant";
// import Layout from "../Layout/Layout";
// import Loader from "../UI/Loader/Loader";
// import defaultImage from "../../assets/svg/jalebi.svg";
// import classes from "./Customers.module.scss";

const Customers = () => {
  // const navigate = useNavigate();
  // const { restaurants, isLoading, error } = useSelector(
  //   (state) => state.restaurant
  // );
  // const dispatch = useDispatch();

  // const selectARestaurant = (id, apiToken) => {
  //   dispatch(selectRestaurant({ id, apiToken }));
  //   navigate("/orders/categories");
  // };

  // useEffect(() => {
  //   if (!restaurants) {
  //     dispatch(fetchAllRestaurants());
  //   }
  // }, [dispatch, restaurants]);

  // let allRestaurants = null;
  // let noRestaurantFound = null;
  // let spinner = null;
  // let errorMessage = null;

  // if (restaurants) {
  //   allRestaurants = (
  //     <div className={classes.Restaurants}>
  //       {restaurants.map((restaurant) => {
  //         return (
  //           // <div
  //           //   key={Math.random(100)}
  //           //   className={classes.Restaurant}
  //           //   onClick={() =>
  //           //     selectARestaurant(
  //           //       restaurant.restaurant.id,
  //           //       restaurant.api_token
  //           //     )
  //           //   }
  //           // >
  //           //   <h2>{restaurant.restaurant.name}</h2>
  //           // </div>
  //           <div
  //             key={Math.random(100)}
  //             className={classes.RestaurantCard}
  //             onClick={() =>
  //               selectARestaurant(
  //                 restaurant.restaurant.id,
  //                 restaurant.api_token
  //               )
  //             }
  //           >
  //             <div className={classes.RestaurantImageBox}>
  //               <img src={defaultImage} alt={restaurant.restaurant.name} />
  //             </div>
  //             <h2 className={classes.RestaurantName}>
  //               {restaurant.restaurant.name}
  //             </h2>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // }

  // if (error) {
  //   errorMessage = <p className={classes.Error}>{error}</p>;
  // }

  // if (!error && !isLoading && !restaurants) {
  //   noRestaurantFound = (
  //     <h2 className={classes.NoRestaurantFound}>No restaurant found.</h2>
  //   );
  // }

  // if (isLoading) {
  //   spinner = (
  //     <div className={classes.LoaderContainer}>
  //       <Loader />
  //     </div>
  //   );
  // }

  return (
    <Fragment>
      <h2>Restaurants</h2>

      {/* {allRestaurants}
      {spinner}
      {noRestaurantFound}
      {errorMessage} */}
    </Fragment>
  );
};

export default Customers;
